import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const RelocationCTA = () => (
  <section className="py-20 lg:py-24 bg-[#FFFFFF]">
    <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
      <h2 className="text-2xl lg:text-3xl text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="consultation-heading">
        Get Your Personalized Relocation Plan
      </h2>
      <p className="text-[#999] mb-10 max-w-xl mx-auto">
        Answer 8 quick questions and get a personalized relocation blueprint built around your situation.
      </p>
      <Link
        to="/relocation/blueprint"
        className="inline-flex items-center gap-3 bg-[#E8A830] text-white px-10 py-4 text-sm font-semibold rounded-lg hover:bg-[#a8511f] transition-all group"
        data-testid="cta-get-blueprint"
      >
        Start Your Blueprint
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </Link>
    </div>
  </section>
);

export default RelocationCTA;
